import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Button, Select as AntSelect } from 'antd';
import { getVenues } from '../../api/venue';

const { Option } = AntSelect;

const EventEditForm = ({ visible, onCancel, onSubmit, initialValues }) => {
    const [form] = Form.useForm();
    const [venues, setVenues] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }
    }, [initialValues, form]);

    useEffect(() => {
        const fetchVenues = async () => {
            try {
                const venuesData = await getVenues();
                setVenues(venuesData);
            } catch (error) {
                console.error('Error fetching venues:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchVenues();
    }, []);

    const handleFinish = (values) => {
        onSubmit(values);
        form.resetFields(); // Reset the form fields after submission  
    };

    return (
        <Modal visible={visible} onCancel={onCancel} footer={null} title="Edit Event">
            <Form form={form} onFinish={handleFinish} layout="vertical">
                <Form.Item label="Event Name" name="name" rules={[{ required: true, message: 'Please input the event name' }]}>
                    <Input placeholder='Enter Name' />
                </Form.Item>
                <Form.Item label="Style" name="style" rules={[{ required: true, message: 'Please input the style' }]}>
                    <Input placeholder='Enter Style' />
                </Form.Item>
                <Form.Item label="Group Type" name="solo_bool" rules={[{ required: true, message: 'Please select the group type' }]}>
                    <AntSelect placeholder="Select group type">
                        <Option value={true}>Solo</Option>
                        <Option value={false}>Group</Option>
                    </AntSelect>
                </Form.Item>
                <Form.Item label="Venue" name="venue" rules={[{ required: true, message: 'Please select the venue' }]}>
                    <AntSelect placeholder="Select Venue" loading={loading}>
                        {venues.map(venue => (
                            <Option key={venue._id} value={venue._id}>
                                {venue.venue}
                            </Option>
                        ))}
                    </AntSelect>
                </Form.Item>
                <Form.Item label="Duration (seconds)" name="duration" rules={[{ required: true, message: 'Please input the duration' }]}>
                    <Input type='number' min={0} placeholder='Enter Duration' />
                </Form.Item>
                <Button type="primary" htmlType="submit">Submit</Button>
            </Form>
        </Modal>
    );
};

export default EventEditForm;  